module.exports = __webpack_public_path__ + "img/intelligentDefense_checked.fa1feaca.png";